<template>
    <div class="calendar-date-selector">
        <span @click="selectPrevious">
            <svg id="Component_108_1" data-name="Component 108 – 1" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <g id="Rectangle_92" data-name="Rectangle 92" fill="#fff" stroke="rgba(72,127,255,0.12)" stroke-width="1">
                    <rect width="28" height="28" rx="5" stroke="none"/>
                    <rect x="0.5" y="0.5" width="27" height="27" rx="4.5" fill="none"/>
                </g>
                <g id="arrow-right-line" transform="translate(24 24) rotate(180)" opacity="0.77">
                    <path id="Path_49" data-name="Path 49" d="M0,0H20V20H0Z" fill="none"/>
                    <path id="Path_50" data-name="Path 50" d="M13.129,9.257,9.106,5.272l1.06-1.05L16,10l-5.833,5.778-1.06-1.05,4.023-3.985H4V9.257Z" fill="#3b4a56"/>
                </g>
            </svg>
        </span>

        <span class="today" @click="selectCurrent">today</span>

        <span @click="selectNext">
            <svg id="Component_109_1" data-name="Component 109 – 1" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
                <g id="Rectangle_93" data-name="Rectangle 93" fill="#fff" stroke="rgba(72,127,255,0.12)" stroke-width="1">
                    <rect width="28" height="28" rx="5" stroke="none"/>
                    <rect x="0.5" y="0.5" width="27" height="27" rx="4.5" fill="none"/>
                </g>
                <g id="arrow-right-line" transform="translate(4 4)" opacity="0.77">
                    <path id="Path_49" data-name="Path 49" d="M0,0H20V20H0Z" fill="none"/>
                    <path id="Path_50" data-name="Path 50" d="M13.129,9.257,9.106,5.272l1.06-1.05L16,10l-5.833,5.778-1.06-1.05,4.023-3.985H4V9.257Z" fill="#3b4a56"/>
                </g>
            </svg>
        </span>
    </div>
</template>

<script>
    import dayjs from "dayjs";

    export default {
        name: "CalendarDateSelector",

        props: {
            currentDate: {
                type: String,
                required: true
            },

            selectedDate: {
                type: Object,
                required: true
            }
        },

        methods: {
            selectPrevious() {
                let newSelectedDate = dayjs(this.selectedDate).subtract(1, "month");
                this.$emit("dateSelected", newSelectedDate);
            },

            selectCurrent() {
                let newSelectedDate = dayjs(this.currentDate);
                this.$emit("dateSelected", newSelectedDate);
            },

            selectNext() {
                let newSelectedDate = dayjs(this.selectedDate).add(1, "month");
                this.$emit("dateSelected", newSelectedDate);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .calendar-date-selector {
        font-family:satoshi, $poppins !important;
        font-size: 0.84em;
        font-weight: 600;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 65%;
        position: relative;

        .today {
            padding: 0 0.3em;
            opacity: 0.6;
            font-weight: 400;
            font-size: 0.78em;
        }

        svg {
            width: 1.5em;
        }
    }

    .calendar-date-selector > * {
        cursor: pointer;
        user-select: none;
    }
</style>